import React, { useState, useEffect } from "react";
// import dayjs from 'dayjs';

import { Card, Button, Grid, Stack } from "@mui/material";
import TextField from '@mui/material/TextField';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { SearchIcon as SearchRoundedIcon } from "components/icons";

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import * as AppConstants from "AppConstants";
import { loadLeavePlansFromBackendForClient } from "app/services/client.service";
import { checkUserHasClientRole, getCurrentClient } from "app/services/app.state.service";
import { isEmpty } from "utils/validationUtil";
// import { getCurrentMonthStartDate } from "utils/dateUtil";
import { handleAxiosError } from "app/services/app.error.handler";
import { LeavePlanDataGridBase } from "app/components/leave-plans/LeavePlanDataGridBase";
import { useDispatch, useSelector } from "react-redux";
import { leaveActions } from "store/leave-slice";

export const LeavePlansForClient = () => {
    const dispatch = useDispatch();
    const [fromDate, setFromDate] = useState(useSelector((state) => state.leave.filter.startDate));
    const [toDate, setToDate] = useState(useSelector((state) => state.leave.filter.endDate));
    const leavePlansData = useSelector((state) => state.leave.rows);
    const [clientId, setClientId] = React.useState();

    useEffect(() =>  {
        if(!checkUserHasClientRole()) return;

        if(leavePlansData.length === 0){
            Promise.resolve(getCurrentClient())
            .then((client) => {
                if(isEmpty(client)) return;
                
                setClientId(client.id);
            
                
                getLeavePlansFromBackend(clientId, fromDate, toDate); 
            });
        }
    }, [clientId, fromDate, toDate]);

    const searchClickHandler = async () => {
        getLeavePlansFromBackend(clientId, fromDate, toDate); 
    }

    const getLeavePlansFromBackend = async (clientId, fromDate, toDate) => {
        dispatch(leaveActions.replaceFilter({startDate: fromDate, endDate : toDate}));
        await loadLeavePlansFromBackendForClient(clientId, fromDate, toDate)
        .then(response => { 
            dispatch(leaveActions.replaceData(response.data));
        })
        .catch(error=>{
            dispatch(leaveActions.replaceData([])); // Set the empty data in leave plans table
            handleAxiosError(error);
        });
    };
      
    if(!checkUserHasClientRole()) {
        return <div>You do not have access to this functionality.</div>;
    }
    return (
        <Grid item xs={12} sm={12} md={12}>
            <Card>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={1}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                >
                    <MDTypography variant="h6" color="white">
                        Leave Plans
                    </MDTypography>
                </MDBox>
                <MDBox mt={3} p={2} >
                    <Stack
                        direction="row" 
                        spacing={2}
                    >
                        <MDBox>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From"
                                    value={fromDate}
                                    onChange={(newFromDate) => {
                                        setFromDate(newFromDate);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                    inputFormat={AppConstants.DATE_FORMAT_DISPLAY}
                                />
                            </LocalizationProvider>
                        </MDBox>
                        <MDBox>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="To"
                                    value={toDate}
                                    onChange={(newToDate) => {
                                        setToDate(newToDate);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                    inputFormat={AppConstants.DATE_FORMAT_DISPLAY}
                                />
                            </LocalizationProvider>
                        </MDBox>
                        <MDBox>
                            <Button 
                                onClick={searchClickHandler}
                                sx={{width:140, m: 0}}
                                variant="contained" 
                                color="success"
                                endIcon={<SearchRoundedIcon />}
                            >
                                Search
                            </Button>
                        </MDBox>
                    </Stack>
                </MDBox>

                <LeavePlanDataGridBase leavePlansData={leavePlansData} />
            </Card>
            
        </Grid>
    );
}